import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Servicio para gestionar un estado de carga global mediante un contador de referencias.
 * Permite que múltiples operaciones concurrentes registren su estado de carga.
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loadingCount = 0;
  private _isLoading = new BehaviorSubject<boolean>(false);

  /**
   * Observable que emite el estado actual de carga.
   */
  isLoading$ = this._isLoading.asObservable();

  /**
   * Incrementa el contador de referencias y activa el estado de carga si es la primera.
   */
  show(): void {
    this._loadingCount++;

    if (this._loadingCount === 1) {
      Promise.resolve().then(() => this._isLoading.next(true));
    }
  }

  /**
   * Decrementa il contador de referencias. Si llega a cero, desactiva el estado de carga.
   */
  hide(): void {
    if (this._loadingCount > 0) {
      this._loadingCount--;

      if (this._loadingCount === 0) {
        Promise.resolve().then(() => this._isLoading.next(false));
      }
    }
  }

  /**
   * Reinicia el contador a cero y desactiva el estado de carga inmediatamente.
   * Útil para limpiezas tras errores críticos o cambios de ruta.
   */
  reset(): void {
    this._loadingCount = 0;
    Promise.resolve().then(() => this._isLoading.next(false));
  }
}
